<section *ngIf="hasAlerts">
  <div *ngFor="let alert of alerts" class="hidden-print">
    <div *ngIf="alert.showAlert" [ngClass]="alert.type" class="dismissibleAlert">
      <table style="width: 100%; height: 100%">
        <tr>
          <td valign="top" [hidden]="alert?.imageurl?.length == 0"><img *ngIf="alert.imageurl" [src]="alert.imageurl"/></td>
          <td><span *ngIf="alert.dismissible" (click)="closeAlert(alert)" class="alert-btn-close"></span>
            <div class="message">
              <header ng-show="alert.header.length > 0">
                <h4>{{alert.header}}</h4>
              </header>
              <div class="bodyText">{{alert.content}}<a *ngIf="alert.showLink" [href]="alert.linkurl" class="linkText">{{alert.linktext}}</a></div>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="vspacer"></div>
  </div>
</section>
